export default {
  most_popular: '#{{rank}} Plus aimé',
};
